import styled from "styled-components";
import InputField from "../../common/InputField/InputField";
import { COLORS } from "../../../assets/constants/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

export const SearchWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
`;

export const SearchModeContainer = styled.div`
  min-width: 200px;
`;

export const SearchContainer = styled.div`
  flex: 1;
  min-width: 250px;
`;

export const OrganizationDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const FilterInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0.5rem 1rem;
  font-size: 14px;
  color: ${COLORS.black};
  border: 1px solid ${COLORS.lightGrey};
  border-radius: 0.25rem;
  outline: none;
  transition: all 0.3s;

  &:focus {
    border-color: ${COLORS.violet};
    box-shadow: 0 0 0 1px ${COLORS.violet};
  }

  &::placeholder {
    color: ${COLORS.lightGrey};
  }
`;

export const ResultsCount = styled.div`
  margin-bottom: 1rem;
  color: ${COLORS.lightGrey};
  font-size: 0.875rem;
`;

export const ErrorMessage = styled.div`
  color: ${COLORS.red};
  background-color: ${COLORS.lightestViolet};
  border: 1px solid ${COLORS.red};
  border-radius: 0.25rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  font-size: 0.875rem;
`;

export const PaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid ${COLORS.lightGrey};
  gap: 1rem;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const PageInfo = styled.div`
  color: ${COLORS.lightGrey};
  font-size: 0.875rem;
`;

export const PageButtonsContainer = styled.div`
  display: flex;
  gap: 0.25rem;
`;

export const PageButton = styled.button`
  padding: 0.5rem 0.75rem;
  background: ${(props) => (props.active ? COLORS.violet : COLORS.white)};
  color: ${(props) => (props.active ? COLORS.white : COLORS.black)};
  border: 1px solid
    ${(props) => (props.active ? COLORS.violet : COLORS.lightGrey)};
  border-radius: 0.25rem;
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s;

  &:hover:not(:disabled) {
    background: ${(props) =>
      props.active ? COLORS.darkViolet : COLORS.lightestViolet};
    border-color: ${(props) =>
      props.active ? COLORS.darkViolet : COLORS.lightGrey};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const PageEllipsis = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 0.75rem;
  color: ${COLORS.lightGrey};
  font-size: 0.875rem;
`;
